import React from 'react';

class MeetingMemberAlerts extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    $(document).on('mouseover', '.wb-m-alert-box .wb-m-title', function () {
      showMeetingAlert($(this));
    });
    $(document).on('mouseout', '.wb-m-alert-box .wb-m-title', function () {
      removeMeetingAlert($(this));
    });
  }

  render() {
    const { props } = this;
    const { membersAlerts } = props;
    const { selectedUser } = props;
    const { userPermission } = props;
    const alerts = membersAlerts.users[selectedUser.id] || {};
    const alertText = membersAlerts.text;
    const isDoing = (userPermission.execute && typeof alerts.doing !== 'undefined' && alerts.doing);
    const isPriority = (userPermission.execute && typeof alerts.priority !== 'undefined' && alerts.priority);
    const isGoal = (userPermission.goal && typeof alerts.goal !== 'undefined' && !alerts.goal);
    const isDelegated = (userPermission.execute && typeof alerts.delegated !== 'undefined' && alerts.delegated);
    const view = (isDoing || isPriority || isGoal || isDelegated);
    if (!view) {
      return null;
    }
    return (
      <div className="wb-m-alert-box left">
        <div className="wb-m-alter-text">Alerts:</div>
        { isDoing
          ? <div className="wb-m-doing-icon wb-m-title" data-title={alertText.doing}>&nbsp;</div> : ''
                }
        { isPriority
          ? <div className="wb-m-priority-icon wb-m-title" data-title={alertText.priority}>&nbsp;</div> : ''
                }
        { isGoal
          ? <div className="wb-m-goal-icon wb-m-title" data-title={alertText.goal}>&nbsp;</div> : ''
                }
        { isDelegated
          ? <div className="wb-m-delagated-icon wb-m-title" data-title={alertText.delegated}>&nbsp;</div> : ''
                }
      </div>
    );
  }
}
export default MeetingMemberAlerts;
